import React, {useEffect, useState} from 'react'
import Navbar from 'src/components/Navbar'
import Footer from 'src/components/Footer2'
import {Outlet, useNavigate} from "react-router-dom";
import {useAppContext} from "../context/user/UserAppProvider";
import ShowLoading from "../components/ShowLoading";

const PageLayout = () => {
    localStorage.removeItem("redirectUrl");
    const navigate = useNavigate()
    const {userRole, onLogout, stakeholderRoles} = useAppContext()
    const [show, setShow] = useState(true)
    useEffect(() => {
        if (userRole || stakeholderRoles) {
            if (stakeholderRoles?.includes('Employer') || stakeholderRoles?.includes('Government') || stakeholderRoles?.includes('Academy')) {
                navigate(`/employer/dashboard`, {
                    replace: true,
                })
                return
            }
            if (userRole[0] === "Super Administrator") {
                navigate(`/admin/dashboard`, {
                    replace: true,
                })
                return
            }
            navigate(`/user/choose-skill-set`, {
                replace: true,
            })
            return
        }
        onLogout();
        setShow(false)
    }, [])
    if (show) {
        return <ShowLoading/>
    }
    return (
        <div className="h-100">
            <Navbar/>
            <div className="main">
                <Outlet/>
            </div>
            <div className={'landing-page'}>

                <Footer/>
            </div>
        </div>
    )
}


export default PageLayout
